module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"readLess":"Read less","readMore":"Read more"}}')
  delete Component.options._Ctor
}
